import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { CaretDown } from "components/icons/CaretDown";

type AuthButtonBarProps = {
  onBack?: () => void;
  onNext?: () => void;
  backDisabled?: boolean;
  nextDisabled?: boolean;
  isLoading?: boolean;
  showBackButton?: boolean;
};

export const AuthButtonBar = ({
  onBack,
  onNext,
  backDisabled = false,
  nextDisabled = false,
  isLoading = false,
}: AuthButtonBarProps) => {
  return (
    <div
      className={classNames("t-flex", {
        "t-justify-start": nextDisabled,
        "t-justify-end": backDisabled,
        "t-justify-between": !nextDisabled && !backDisabled,
      })}
    >
      {!backDisabled && (
        <Button
          onClick={onBack}
          disabled={isLoading}
          customType="link_neutral"
          type="button"
          size="small"
        >
          <CaretDown className="t-rotate-90 t-mr-1" /> Go back
        </Button>
      )}

      {!nextDisabled && (
        <Button
          onClick={onNext}
          disabled={isLoading}
          type="button"
          customType="link_neutral"
          size="small"
        >
          Next <CaretDown className="t-ml-1 -t-rotate-90" />
        </Button>
      )}
    </div>
  );
};
